import { createConfigSelector } from '@americanexpress/travel-selectors';
import {
  AXP_CLIENT_HOME_API_URL,
  AXP_CLIENT_TLSONLINE_WRAPPER_SERVICES_URL,
  AXP_CLIENT_TULIPS_SMART_FILL_API_URL,
  ONE_CMS_INTERNET_SSR_BASE_URL,
  AXP_CLIENT_APIGEE_URL,
  EWP_DOMAIN,
} from '../iguazu-rest/baseUrls';

export const getHomeApiUrl = createConfigSelector(AXP_CLIENT_HOME_API_URL);
export const getTravelerApiUrl = createConfigSelector('travelerApiUrl');
export const getTLSOnlineWrapperApiUrl = createConfigSelector(
  AXP_CLIENT_TLSONLINE_WRAPPER_SERVICES_URL
);
export const getTulipsSmartFillApiUrl = createConfigSelector(AXP_CLIENT_TULIPS_SMART_FILL_API_URL);
export const getOneCMSInternetSSRApiUrl = createConfigSelector(ONE_CMS_INTERNET_SSR_BASE_URL);
export const getFaasApiUrl = createConfigSelector('faasApiUrl');
export const getApigeeUrl = createConfigSelector(AXP_CLIENT_APIGEE_URL);
export const getEWPDomain = createConfigSelector(EWP_DOMAIN);
